// extracted by mini-css-extract-plugin
export default {"media":"index_media_4yzn6","picInfo":"index_picInfo_U5HXh","picList":"index_picList_Fc-T5"};